
(function(){
  document.addEventListener('DOMContentLoaded', function() {
		
		function isVideoPlay(that) {
			console.log('that',that.el);
			if ( that.el.querySelectorAll('.swiper-slide-active .deferred-media__poster')?.length > 0 ) {
				that.el.querySelector('.swiper-slide-active .deferred-media__poster').click();
				
				setTimeout(() => {
					// console.log("Delayed for 1 second.");
						if ( that.el.querySelector('.swiper-slide-active video')?.length > 0 ) {
						let video = that.el.querySelector('.swiper-slide-active video');
						try {
							video[0].play();
						} catch (error) {
							console.log(error);
						}
					}
				}, "1000");
			}
			if ( that.el.querySelectorAll('.swiper-slide-active video').length > 0 ) {
				let video = that.el.querySelectorAll('.swiper-slide-active video');
				
				try {
					video[0].play();
				} catch (error) {
					console.log(error);
				}
			}
		}

		// function clickVideosOnLoad() {
		// 	if ( document.querySelectorAll('.slider-card-main .deferred-media__poster').length > 0 ) {
		// 		let videos = document.querySelectorAll('.slider-card-main .deferred-media__poster');
		// 		videos.forEach(elem => {
		// 			elem.click();
		// 		});
		// 	}
		// }
		// clickVideosOnLoad();

		// function playVideoOnActiveSlide() {

		// 	// Pause all existing videos
		// 	let videos = document.querySelectorAll(
		// 		".slider-card-main video"
		// 	);
		// 	videos.forEach(function (video) {
		// 		video.pause();
		// 		video.currentTime = 0;
		// 	});

		// 	// Find the active slide
		// 	let activeSlide = document.querySelector(
		// 		".slider-card-main .swiper-slide-active"
		// 	);

		// 	if (activeSlide) {
		// 		// Check if a video is already present in the slide
		// 		let video = activeSlide.querySelector("video");

		// 		// If video not yet loaded, load it from the <template>
		// 		if (!video) {
		// 			let template = activeSlide.querySelector("template");
		// 			if (template) {
		// 				// Clone the video node from the template
		// 				let videoElement = template.content
		// 					.querySelector("video")
		// 					.cloneNode(true);

		// 				// Insert the video into the slide (you can append to a container if needed)
		// 				activeSlide.appendChild(videoElement);

		// 				// Optional: add a slight delay to ensure it’s properly rendered before play
		// 				setTimeout(() => {
		// 					videoElement.play();
		// 				}, 100);
		// 			}
		// 		} else {
		// 			// If video already exists, just play it
		// 			video.play();
		// 		}
		// 	}
		// }
		
		
    window.initProductCardSliders = function initProductCardSliders() {
			let cards = document.querySelectorAll('.slider-card-main');
			if ( cards ) {
				cards.forEach(elem => {
					new Swiper(elem, {
						spaceBetween: 0,
						slidesPerView: 1,
						loop: true,
						grabCursor: false,
						navigation: {
							nextEl: elem.querySelector('.swiper-button-next'),
							prevEl: elem.querySelector('.swiper-button-prev'),
						},
						on: {
              slideChangeTransitionEnd: function () {
                isVideoPlay(this);
								// playVideoOnActiveSlide();
              },
            },
						breakpoints: {
							750: {
								// 750px and more
								//slidesPerView: 1.1,
								slidesPerView: 1,
								spaceBetween: 10,
								centeredSlides: false,
								initialSlide: 0,
							},
							990: {
								//slidesPerView: 1.1,
								slidesPerView: 1,
								spaceBetween: 30,
								centeredSlides: false,
							},
						},
					});
				}); 
				
			}
			
		}
  	window.initProductCardSliders();
	}, false);
})();